export default __webpack_public_path__ + "static/media/sales-volume.f26a6474.png";